export function disabledAttr(disabled) {
    return disabled ? true : undefined;
}
